var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-page-header',{attrs:{"title":"人脸识别签到"}}),_c('ui-stage',[_c('ui-flex',{attrs:{"col":"","center":""}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.qr),expression:"!qr"}]},[_c('vue-qrious',{attrs:{"value":_vm.qr,"size":200}})],1),_c('div',{staticClass:"mt"},[_vm._v("使用”智慧工地“APP扫描上方二维码进入人脸识别签到")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }